import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { REFRESH_TOKEN_URL } from "./url";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

export const apiCall = async (
  url,
  method = "GET",
  data = null,
  isFormData = false,
  showToast = true,
  isRetry = false,
) => {
  try {
    const token = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");

    const headers = {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    const config = {
      method: method.toUpperCase(),
      headers,
    };

    if (data && method.toUpperCase() !== "GET") {
      config.body = isFormData ? data : JSON.stringify(data);
    }

    const fullUrl = process.env.REACT_APP_API_URL + url;

    const response = await fetch(fullUrl, config);
    const responseJson = await response.json().catch(() => ({}));

    if (response.status === 401 && !isRetry && url !== REFRESH_TOKEN_URL) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => {
            return apiCall(url, method, data, isFormData, showToast, true);
          })
          .catch((err) => {
            throw err;
          });
      }

      isRefreshing = true;

      try {
        const refreshRes = await fetch(process.env.REACT_APP_API_URL + REFRESH_TOKEN_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ refreshToken }),
        });
        const refreshData = await refreshRes.json();
        const newToken = refreshData?.results?.accessToken || refreshData?.accessToken;
        const newRefreshToken = refreshData?.results?.refreshToken || refreshData?.refreshToken;

        if (!refreshRes.ok || !newToken) {
          throw new Error(refreshData?.message || "Refresh failed");
        }

        localStorage.setItem("accessToken", newToken);
        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }
        processQueue(null, newToken);
        isRefreshing = false;
      } catch (err) {
        processQueue(err, null);
        isRefreshing = false;

        localStorage.clear();
        window.location.href = "/";

        throw err;
      }

      return apiCall(url, method, data, isFormData, showToast, true);
    }

    if (response.ok) {
      if (showToast && method !== "GET") {
        toast.success(responseJson?.message || "Success");
      }
      return responseJson;
    }

    throw {
      message: responseJson?.message || "Something went wrong",
      status: response.status,
    };
  } catch (error) {
    if (showToast) {
      toast.error(error?.message || "Network error");
    }

    throw error;
  }
};
